import type { CSSProperties } from 'react';

type Props = {
  url?: string | null;
  name: string;
  color: string;
  size?: number;
  borderColor?: string;
  fontSize?: number;
  style?: CSSProperties;
};

export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function Avatar({ url, name, color, size = 32, borderColor = 'var(--ink)', fontSize, style }: Props) {
  const baseStyle: CSSProperties = {
    width: size,
    height: size,
    borderRadius: '50%',
    background: color,
    border: `1.5px solid ${borderColor}`,
    color: 'var(--cream)',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Bevan',
    fontSize: fontSize ?? Math.max(9, Math.round(size * 0.36)),
    letterSpacing: '0.04em',
    overflow: 'hidden',
    flexShrink: 0,
    ...style,
  };

  if (url) {
    return (
      <span style={baseStyle} aria-label={name}>
        <img
          src={url}
          alt=""
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
      </span>
    );
  }

  return (
    <span style={baseStyle} aria-label={name}>
      {initialsOf(name)}
    </span>
  );
}
